import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { ModeContext } from '../../../../context';
import { Mode } from '../../../../types';
import { getGdsServicesCalculatedCountInfo } from '../../../../Checkout/store/selectors';
import { getGdsServicesCalculatedCountInfo as checkinGdsServicesCalculatedCountInfo } from '../../../../Modules/Checkin/store/selectors';
export function useGdsServicesCalculatedCountInfo() {
    const mode = useContext(ModeContext);
    let gdsServicesCalculatedCountInfo;
    if (mode === Mode.Checkin) {
        gdsServicesCalculatedCountInfo = useSelector(checkinGdsServicesCalculatedCountInfo);
    }
    else {
        gdsServicesCalculatedCountInfo = useSelector(getGdsServicesCalculatedCountInfo);
    }
    return gdsServicesCalculatedCountInfo;
}
